
















import { defineComponent, ref } from "@vue/composition-api";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import useUserTags from "@/hooks/useUserTags";
import TagsController from "@/components/TagsController";

export default defineComponent({
  name: "UserContentType",
  components: {
    TagsController,
  },
  setup(_, { emit }) {
    const { userContentTypes, userTagsGetData, userContentTypesUpdateData } = useUserTags();

    const loading = ref(false);

    const onInput = (tags: TagInfo[]) => {
      userContentTypes.value = tags.map(tag => tag.id);
      emit("setValid", !!userContentTypes.value.length);
    };

    const saveFields = () => {
      return userContentTypesUpdateData(userContentTypes.value);
    };

    const created = async () => {
      emit("setValid", false);
      emit("setCb", saveFields);
      try {
        loading.value = true;
        emit("setLoading", true);
        await userTagsGetData();
      } finally {
        loading.value = false;
        emit("setLoading", false);
      }
    };

    created();

    return {
      loading,
      userContentTypes,
      onInput,
      TagInfoType,
    };
  },
});
